import { createFileRoute } from '@tanstack/react-router'
import { CREDIT_ROUTES, toStaticData } from '../../credit-route-config'

export const Route = createFileRoute('/_auth/_modules/credit/blocked-orders/pending')({
  staticData: toStaticData(CREDIT_ROUTES['/credit/blocked-orders/pending']),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
